import PopEdit from '@/components/business/PopEdit';
import useI18n from '@/hooks/useI18n';
import { useModel } from '@umijs/max';
import { useUnmount } from 'ahooks';
import { Button, Input, Table, message } from 'antd';
import { isEmpty } from 'lodash';
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';
import memberCommon from '../../../memberCommon';
import OfferDetailModal from '../../OfferDetailModal';

export interface ISelectRoleProps {
  queryParams?: any;
  value?: any;
  isNeedQryNewOffer?: boolean;
  onChange?: (val: unknown) => void;
  onSelectChange?: (val: unknown) => void;
}

const SelectOfferPopEdit = (
  {
    value,
    queryParams,
    isNeedQryNewOffer,
    onChange,
    onSelectChange,
  }: ISelectRoleProps,
  ref: any,
) => {
  const {
    selectedRows = [],
    offerList = [],
    queryOffers,
    currentOffer,
    setCurrentOffer,
    offerDetailSystem,
    offerGradeSystem,
    mutateOfferData,
  } = useModel('MemberMgr.memberModel');
  const { isNeedOfferDetailModal } = memberCommon;
  const { formatMessage } = useI18n();
  const [selectedOffer, setSelectedOffer] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>();
  const [searchValue, setSearchValue] = useState<string>('');
  const { currencyTypeData = 'RM' } = useModel('global');

  // const {
  //   data: bundleMembers = [],
  //   loading,
  //   run: queryBundleMembers,
  // } = useRequest(queryBundleMemberService, { manual: true });

  // // 使用 flatMap 和 filter 处理数据
  // const newArray = useMemo(
  //   () =>
  //     bundleMembers?.flatMap((member: any) =>
  //       member.bundleUnitProductOffering
  //         .filter(
  //           (offering: any) =>
  //             offering.servType === String(selectedRows?.[0]?.servType),
  //         ) // 直接比较字符串
  //         .map((offering: any) => ({
  //           ...offering, // 保留其他属性
  //           name: offering.productOfferingName, // 新属性 name
  //           id: offering.productOfferingId, // 新属性 id
  //           code: offering.productOfferingId, // 新属性 code
  //         })),
  //     ),
  //   [bundleMembers],
  // );

  useEffect(() => {
    if (queryParams) {
      queryOffers(
        queryParams
          ? queryParams
          : {
              sourceProductOfferingIds: [selectedRows[0]?.subsPlan?.offerId], // 选中记录的第一条
              relationship: '3', // 固定值
              productOfferingType: [1], // 固定值
              channel: '18', // 取当前渠道 目前是固定值
              grade: offerGradeSystem || '1,3',
              marketSegment: [
                {
                  segmentType: 1,
                },
              ],
            },
      );
    } else if (!selectedRows[0]?.bundleOfferId) {
      queryOffers({
        sourceProductOfferingIds: [selectedRows[0]?.subsPlan?.offerId], // 选中记录的第一条
        relationship: '3', // 固定值
        productOfferingType: [1], // 固定值
        channel: '18', // 取当前渠道 目前是固定值
        grade: offerGradeSystem || '1,3',
        marketSegment: [
          {
            segmentType: 1,
          },
        ],
      });
    }
    // bundle子成员change offer调用productOffering接口
    if (selectedRows[0]?.bundleOfferId) {
      queryOffers({
        sourceProductOfferingIds: [selectedRows[0]?.subsPlan?.offerId], // 选中的子成员套餐id
        relationship: '3', // 固定值
        productOfferingType: [1], // 固定值
        channel: '18', // 取当前渠道 目前是固定值
        grade: offerGradeSystem || '1,3',
        bundleOfferId: selectedRows[0]?.bundleOfferId, // 当前所属bundle的bundleId
        marketSegment: [
          {
            segmentType: 1,
          },
        ],
      });
    }
  }, [selectedRows]);

  useImperativeHandle(ref, () => ({
    selectedOffer: selectedOffer[0],
  }));

  const columns = [
    {
      title: formatMessage('memberMgr.name'),
      dataIndex: 'name',
      key: 'name',
      width: 200,
      ellipsis: true,
      render: (text: string, record: any) =>
        isNeedOfferDetailModal ? (
          <Button
            type="link"
            style={{ padding: 0 }}
            onClick={() =>
              setCurrentOffer({
                ...record,
                currentStatus: 'changeOffer',
              })
            }
          >
            {text || ''}
          </Button>
        ) : (
          text || ''
        ),
    },
    {
      title: formatMessage('memberMgr.salePrice', {
        currencySymbol: currencyTypeData,
      }),
      dataIndex: isNeedQryNewOffer ? 'saleListPriceDisplay' : 'saleListPrice',
      key: isNeedQryNewOffer ? 'saleListPriceDisplay' : 'saleListPrice',
      ellipsis: true,
      width: isNeedOfferDetailModal ? 150 : 'auto',
    },
    {
      title: formatMessage('memberMgr.rentPrice', {
        currencySymbol: currencyTypeData,
      }),
      dataIndex: isNeedQryNewOffer ? 'rentListPriceDisplay' : 'rentListPrice',
      key: isNeedQryNewOffer ? 'rentListPriceDisplay' : 'rentListPrice',
      ellipsis: true,
      width: isNeedOfferDetailModal ? 150 : 'auto',
    },
    isNeedOfferDetailModal
      ? {
          title: formatMessage('memberMgr.description'),
          key: 'offerDescription',
          width: 120,
          align: 'center',
          render: (text: string, record: any) => (
            <Button
              onClick={() =>
                setCurrentOffer({
                  ...record,
                  currentStatus: 'changeOffer',
                })
              }
            >
              {formatMessage('common.detail')}
            </Button>
          ),
        }
      : {
          hidden: true, // um隐藏这一列
        },
  ];

  const offerDataSource = useMemo(() => {
    const offers = (offerList || [])
      .map((el: any) => {
        return {
          ...(el?.offerBasicInfo ? el.offerBasicInfo : el),
          name: el?.name || el?.offerBasicInfo?.offerName,
          id: el?.id || el?.offerBasicInfo?.offerId,
          code: el?.code || el?.offerBasicInfo?.offerCode,
        };
      })
      ?.filter((ele: any) => ele.id !== selectedRows[0]?.subsPlan?.offerId); // 切换套餐过滤他自己本身
    return isEmpty(searchValue)
      ? offers
      : offers.filter((el: any) =>
          el?.name
            ?.replaceAll(' ', '')
            .toLocaleLowerCase()
            .includes(searchValue.replaceAll(' ', '').toLocaleLowerCase()),
        );
  }, [offerList, searchValue]);

  const handleOk = (callback: { (): void; (): void }) => {
    if (!selectedRowKeys?.length) {
      return message.warning(formatMessage('form.please.select'));
    }
    callback();
    onChange?.(selectedOffer[0]);
    onSelectChange?.(selectedOffer[0]);
    setSelectedRowKeys([]);
  };

  useUnmount(() => {
    mutateOfferData([]);
  });

  return (
    <PopEdit
      width={'60%'}
      title={formatMessage('memberMgr.offerList')}
      value={value?.name || selectedOffer[0]?.name}
      onOk={(callback) => handleOk(callback)}
      onClose={(callback) => {
        callback();
        setSelectedRowKeys([]);
        // setSelectedOffer([]);
      }}
    >
      <Input.Search
        style={{ width: 300, margin: '20px 0px' }}
        placeholder={formatMessage('memberMgr.offerName')}
        allowClear
        onSearch={setSearchValue}
      />
      <Table
        rowKey="id"
        columns={columns}
        dataSource={offerDataSource}
        rowSelection={{
          type: 'radio',
          selectedRowKeys,
          onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
            setSelectedOffer(selectedRows);
            setSelectedRowKeys(selectedRowKeys);
          },
        }}
        scroll={{ y: 400 }}
        pagination={false}
      />
      {isNeedOfferDetailModal &&
      offerDetailSystem === 'Y' &&
      currentOffer?.currentStatus === 'changeOffer' ? (
        <OfferDetailModal onClose={() => setCurrentOffer({})} />
      ) : null}
    </PopEdit>
  );
};
export default forwardRef(SelectOfferPopEdit);
